import request from '@/utils/request';

// 获取营销短信配置
export function fetchMarketSmsConfigDetail(data) {
  return request({
    url: '/config/fetchMarketSmsConfigDetail',
    method: 'POST',
    data
  });
}
// 发送短信
export function saveMarketSmsLog(data) {
  return request({
    url: '/market/sms/log/saveMarketSmsLog',
    method: 'POST',
    data
  });
}
// 查询所有用户
export function queryAllUser(data) {
  return request({
    url: '/market/sms/log/queryAllUser',
    method: 'POST',
    data
  });
}
// 查询所有会员等级
export function queryAllMemberLevel(data) {
  return request({
    url: '/market/sms/log/queryAllMemberLevel',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/sms.js